import React from "react";
import { PARTNERS } from "../data/content";

export default function TechPartners() {
  const items = [...PARTNERS, ...PARTNERS]; // duplicated for infinite marquee
  return (
    <section className="py-16 sm:py-20 border-y border-border overflow-hidden bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <p className="text-xs sm:text-sm font-semibold uppercase tracking-[0.22em] text-muted-foreground">
            Technology alliances we architect &amp; deliver with
          </p>
        </div>
      </div>
      <div className="relative mt-10">
        <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-background to-transparent z-10" />
        <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-background to-transparent z-10" />
        <div className="marquee-track flex gap-4 sm:gap-6 whitespace-nowrap items-center" data-testid="partners-marquee">
          {items.map((p, i) => (
            <div
              key={`${p.name}-${i}`}
              className="shrink-0 h-28 sm:h-32 w-60 sm:w-72 rounded-2xl border border-border bg-white flex items-center justify-center px-6 shadow-sm hover:shadow-md transition-shadow"
              data-testid={`partner-${p.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}-${i}`}
            >
              {p.logo ? (
                <img
                  src={p.logo}
                  alt={`${p.name} logo`}
                  className="max-h-20 sm:max-h-24 max-w-full object-contain"
                  loading="lazy"
                />
              ) : (
                <span className="font-display font-bold text-xl sm:text-2xl tracking-tight text-slate-800">{p.name}</span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
